export default "__VITE_ASSET__B_I_cG9B__"